import type {
  GetAggregatedFormDataParams,
  GetFormTrendsResponse,
} from '#services/api/insights.ts';

import { Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { formTrends } from '#lib/react-query/queries.ts';
import { CHART_X_AXIS_CONFIG, WIDGET_CHART_HEIGHT } from '#utils/charts.ts';
import { EmptyDataOverlay } from '../EmptyDataOverlay.tsx';
import { ViewChart } from './ViewChart.tsx';

function select(response: GetFormTrendsResponse) {
  return {
    ...response,
    data: response.data.map((item) => ({
      ...item,
      period: new Date(item.period),
    })),
  };
}

export function CombinedView(props: { params: GetAggregatedFormDataParams }) {
  const { data, isLoading } = useQuery({
    ...formTrends({ ...props.params, assessmentTypeRequired: undefined }),
    select,
  });

  if (isLoading) {
    return <Skeleton variant="rounded" height={WIDGET_CHART_HEIGHT} />;
  }

  if (!(data && data.data.length > 0)) {
    return <EmptyDataOverlay />;
  }

  return (
    <ViewChart
      dataset={data.data}
      series={[
        {
          dataKey: 'all',
          label: 'Total',
          labelMarkType: 'circle',
          type: 'line',
        },
        {
          dataKey: 'assigned',
          label: 'Assigned',
          labelMarkType: 'circle',
          type: 'line',
        },
        {
          dataKey: 'completed',
          label: 'Completed',
          labelMarkType: 'circle',
          type: 'line',
        },
        {
          dataKey: 'canceled',
          label: 'Canceled',
          labelMarkType: 'circle',
          type: 'line',
        },
      ]}
      xAxis={[
        {
          dataKey: 'period',
          height: 60,
          label: 'Dates',
          scaleType: 'time',
          ...CHART_X_AXIS_CONFIG[data.groupedBy],
        },
      ]}
    />
  );
}
